export type ClientImproveGoal = 'polish' | 'fill' | 'rewrite';

export type ClientEnhancePayload = {
    articleId: string;
    improveGoal?: ClientImproveGoal;
    sectionUids?: string[];
};

const H2_UID = /^h2-\d+$/;

type EnhanceArticle = {
    id?: string | null;
    improveGoal?: string | null;
    sectionUids?: string[] | null;
};

/**
 * Payload for OpenAIArticleGenerate / OpenAIArticleReGenerate.
 * Improve now does not start writing. Enhance article sends the goal and,
 * for Rewrite, the checked H2 ids already on the article.
 */
export function clientEnhanceRequest(article: EnhanceArticle | null | undefined): ClientEnhancePayload {
    const request: ClientEnhancePayload = {articleId: String(article?.id || '')};
    const goal = article?.improveGoal;
    if (goal !== 'polish' && goal !== 'fill' && goal !== 'rewrite') {
        return request;
    }
    request.improveGoal = goal;
    if (goal !== 'rewrite' || !Array.isArray(article?.sectionUids)) {
        return request;
    }
    const uids: string[] = [];
    for (const item of article.sectionUids) {
        const id = String(item || '').trim();
        if (H2_UID.test(id) && uids.indexOf(id) === -1) {
            uids.push(id);
        }
    }
    if (uids.length) {
        request.sectionUids = uids;
    }
    return request;
}
